import { useEffect } from 'react'
import { useRunTierReview } from '../../hooks/backend/tierReview'
import { TIER_REVIEW_CHANGED } from '../../utils/tierReview'

const SESSION_KEY = 'tierReviewChecked'

// Runs the quarterly wholesale tier review the first time the Hub is opened
// after a quarter ends (Jan 1, Apr 1, Jul 1, Oct 1). The backend skips it
// when that quarter already has a review, so this only asks once per browser
// session. Renders nothing.
export default function TierReviewAutoRun() {
  const runReview = useRunTierReview()

  useEffect(() => {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return
      sessionStorage.setItem(SESSION_KEY, '1')
    } catch {
      // Storage unavailable: still check; the backend runs at most once a quarter.
    }
    void runReview
      .trigger({ onlyIfMissing: true })
      .result.then((res: unknown) => {
        if ((res as { ran?: boolean } | undefined)?.ran) window.dispatchEvent(new Event(TIER_REVIEW_CHANGED))
      })
      .catch(() => undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
